<!--
* UIID: UI-CAAS-COM-115
* UI Name: REST-API
* Modify Date: 2020/06/15
-->
<template>
  <div>
    <v-form ref="form">
      <!-- 2 Row 54px-->
      <v-row>
        <v-col cols="12" md="6" class="px-2 py-0">
          <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Host</v-label>
          <v-text-field
            v-model="formData.host"
            :rules="[validationUtils.required, validationUtils.max(100)]"
            solo
            :disabled="!$auth.manage"
            :readonly="isHistory"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="px-2 py-0">
          <v-row>
            <v-col cols="12" md="8" class="py-0 pr-1">
              <!-- // 2021.8.23 203728 SPKA-198 add protocol -->
              <v-label
                ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
                >{{ $t('lbl.common.conditionSearch.protocol') }}</v-label
              >
              <v-select
                v-model="formData.protocol"
                :items="protocolList"
                :rules="[validationUtils.required]"
                solo
                :menu-props="{ offsetY: true }"
                :disabled="!$auth.manage"
                :readonly="isHistory"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4" class="py-0">
              <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Port</v-label>
              <v-text-field
                v-model="formData.port"
                type="number"
                :rules="[validationUtils.required, validationUtils.max(5)]"
                solo
                :disabled="!$auth.manage"
                :readonly="isHistory"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-if="formData.protocol && formData.protocol.indexOf('HTTP') != -1"
          cols="12"
          md="12"
          class="px-2 py-0 right-checkbox"
        >
          <span>{{ $t('lbl.communications.selfCert') }}</span>
          <v-checkbox v-model="formData.selfCert" class="mt-0" dense solo hide-details></v-checkbox>
        </v-col>
      </v-row>
      <!--4 Row 40px-->
      <v-row>
        <v-col cols="12" md="6" class="px-2 py-0">
          <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Method</v-label>
          <v-select
            v-model="formData.method"
            :rules="[validationUtils.required]"
            :items="methods"
            solo
            :menu-props="{ offsetY: true }"
            :disabled="!$auth.manage"
            :readonly="isHistory"
          ></v-select>
        </v-col>
        <v-col cols="12" md="6" class="px-2 py-0">
          <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Path</v-label>
          <v-text-field
            v-model="formData.path"
            :rules="[validationUtils.required, validationUtils.max(200)]"
            solo
            :disabled="!$auth.manage"
            :readonly="isHistory"
          ></v-text-field>
        </v-col>
      </v-row>
      <!--5 Row 40px-->
      <v-row>
        <v-col cols="12" md="12" class="px-2 py-0">
          <v-row>
            <v-col cols="12" md="4" class="pr-0">
              <v-label
                ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
                >{{ $t('lbl.communications.exeInterval') }}</v-label
              >
              <v-text-field
                v-model="formData.interval"
                type="number"
                :rules="[validationUtils.required, validateInterval(intervalDefault)]"
                solo
                :disabled="!$auth.manage"
                :readonly="isHistory"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" class="pr-1">
              <v-select
                v-model="intervalDefault"
                :items="intervals"
                solo
                :menu-props="{ offsetY: true }"
                :disabled="!$auth.manage"
                :readonly="isHistory"
                return-object
                style="margin-top: 22px !important;"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-label
                >{{ $t('lbl.communications.maxRetryAttempts') }}</v-label
              >
              <v-text-field
                v-model="formData.maxRetry"
                type="number"
                solo
                :disabled="!$auth.manage"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" class="px-2 py-0">
          <v-row class="ml-0 mr-0 d-block">
            <v-col lg="6" class="pa-0">
              <v-label>HTTP Headers</v-label>
              <v-icon
                dense
                :disabled="!$auth.manage"
                :readonly="isHistory"
                @click="addHttpHeaders()"
                class="ml-3"
              >
                mdi-plus
              </v-icon>
            </v-col>
          </v-row>
          <v-form ref="formHttpHeaders" class="form-identification pr-0 pb-6">
            <v-row
              class="ml-0 mr-0 edi-identification-right"
              v-for="(item, index) in listHttpHeaders"
              :key="item.id"
            >
              <v-col cols="12" md="4" class="pa-0">
                <v-text-field
                  :ref="'HTTP_' + item.id"
                  solo
                  hide-details
                  v-model="item.keyHeader"
                  :disabled="!$auth.manage"
                  :readonly="isHistory"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="7" class="pa-0 pl-4">
                <v-text-field
                  :ref="'HTTP_' + item.id + '_' + item.id"
                  solo
                  hide-details
                  v-model="item.valueHeader"
                  :disabled="!$auth.manage"
                  :readonly="isHistory"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1" class="pa-0 mt-4 text-right">
                <v-icon
                  dense
                  :disabled="!$auth.manage"
                  :readonly="isHistory"
                  @click="removeHttpHeaders(index)"
                >
                  mdi-minus
                </v-icon>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6" class="px-2 py-0">
          <v-row>
            <v-col cols="12" md="12">
              <v-label>{{ $t('lbl.communications.authType') }}</v-label>
              <v-select
                v-model="formData.authType"
                :items="authList"
                solo
                :menu-props="{ offsetY: true }"
                :disabled="!$auth.manage"
                :readonly="isHistory"
              ></v-select>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row
        v-if="formData.authType"
        class="px-2 mb-2 edi-identification rest-api-form"
        style="height: auto"
      >
        <v-col cols="12" md="12" class="px-4 pt-4" v-if="formData.authType == 'basic'">
          <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>ID</v-label>
          <v-text-field
            v-model="formData.authId"
            solo
            :menu-props="{ offsetY: true }"
            :disabled="!$auth.manage"
            :rules="[validationUtils.required, validationUtils.max(50)]"
            :readonly="isHistory"
            autocomplete="off"
          ></v-text-field>
          <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Password</v-label>
          <v-text-field
            v-model="formData.authPass"
            :rules="[validationUtils.required, validationUtils.max(100)]"
            :append-icon="formData.showpassword ? 'mdi-eye-off' : 'mdi-eye'"
            :type="formData.showpassword ? 'text' : 'password'"
            @click:append="formData.showpassword = !formData.showpassword"
            solo
            :disabled="!$auth.manage"
            :readonly="isHistory"
            autocomplete="off"
            @focus="handlePasswordType"
            @blur="handlePasswordType"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="12" class="pl-0 pr-0 pt-0" v-if="formData.authType == 'apikey'">
          <v-row>
            <v-col cols="12" md="12" class="pr-0 pt-4">
              <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>API Key</v-label>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4" class="pr-0 pt-0">
              <v-text-field
                v-model="formData.authKey"
                solo
                :menu-props="{ offsetY: true }"
                :disabled="!$auth.manage"
                :rules="[validationUtils.required, validationUtils.max(10)]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="8" class="pt-0">
              <v-text-field
                v-model="formData.authToken"
                solo
                :menu-props="{ offsetY: true }"
                :disabled="!$auth.manage"
                :rules="[validationUtils.required, validationUtils.max(255)]"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="12" class="pl-0 pr-0 pt-5" v-if="formData.authType == 'bearer'">
          <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Token URI</v-label>
          <v-text-field
            v-model="formData.accessToken"
            solo
            :menu-props="{ offsetY: true }"
            :disabled="!$auth.manage"
            :rules="[validationUtils.required, validationUtils.max(250)]"
          ></v-text-field>
          <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Client ID</v-label>
          <v-text-field
            v-model="formData.authClientID"
            solo
            :menu-props="{ offsetY: true }"
            :disabled="!$auth.manage"
            :rules="[validationUtils.required, validationUtils.max(30)]"
          ></v-text-field>
          <v-row>
            <v-col cols="12" md="2" style="margin-top: 18px;">
              <v-label>Basic Auth</v-label>
            </v-col>
            <v-col cols="12" md="5">
              <v-text-field
                v-model="formData.authId"
                solo
                hide-details
                :menu-props="{ offsetY: true }"
                :disabled="!$auth.manage"
                :rules="formData.authId ? [validationUtils.max(50)] : []"
                :readonly="isHistory"
                autocomplete="off"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="5">
              <v-text-field
                v-model="formData.authPass"
                :rules="formData.authPass ? [validationUtils.max(100)] : []"
                :append-icon="formData.showpassword ? 'mdi-eye-off' : 'mdi-eye'"
                :type="formData.showpassword ? 'text' : 'password'"
                @click:append="formData.showpassword = !formData.showpassword"
                solo
                :disabled="!$auth.manage"
                :readonly="isHistory"
                autocomplete="off"
                @focus="handlePasswordType"
                @blur="handlePasswordType"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="2" style="margin-top: 18px;">
              <v-label>API Key</v-label>
            </v-col>
            <v-col cols="12" md="5">
              <v-text-field
                v-model="formData.authKey"
                solo
                hide-details
                :menu-props="{ offsetY: true }"
                :disabled="!$auth.manage"
                :rules="formData.authKey ? [validationUtils.max(10)] : []"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="5">
              <v-text-field
                v-model="formData.authToken"
                solo
                hide-details
                :menu-props="{ offsetY: true }"
                :disabled="!$auth.manage"
                :rules="formData.authToken ? [validationUtils.max(255)] : []"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-col cols="12" md="12" class="pl-0 pr-4 mb-2 pt-4">
            <v-row class="ml-0 mr-0 d-block">
              <v-col lg="6" class="pa-0">
                <v-label>Headers</v-label>
              </v-col>
              <v-tooltip top :disabled="bearerHeadersList.length < maxPattern">
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="btn-tooltip">
                    <v-col lg="6" class="pa-0 mb-1 text-right">
                      <v-icon
                        dense
                        @click="addPattern('BHEAD')"
                        :disabled="!$auth.manage || bearerHeadersList.length > maxPattern - 1"
                      >
                        mdi-plus
                      </v-icon>
                    </v-col>
                  </div>
                </template>
                <span v-html="$t('lbl.communications.validMaxPattern')"></span>
              </v-tooltip>
            </v-row>
            <v-form
              ref="formHeaders"
              class="dialog-content pr-0 mb-2"
              v-on:submit.prevent="doNoThing"
            >
              <v-row
                class="ml-0 mr-0 mb-4 edi-identification"
                v-for="(item, indexHeaders) in bearerHeadersList"
                :key="indexHeaders"
              >
                <v-col cols="12" md="4" class="pa-0">
                  <v-tooltip top :disabled="!item.isValidatePattern">
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <v-text-field
                          :ref="'BHEAD_' + indexHeaders"
                          solo
                          hide-details
                          v-model="item.keyHeader"
                        ></v-text-field>
                      </div>
                    </template>
                    <span v-html="$t('lbl.communications.validDuplicatePattern')"></span>
                  </v-tooltip>
                </v-col>
                <v-col cols="12" md="7" class="pa-0 pl-2">
                  <v-text-field
                    :ref="'BHEAD_' + indexHeaders + '_' + indexHeaders"
                    solo
                    hide-details
                    v-model="item.valueHeader"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="1" class="pa-0 mt-2 text-center">
                  <v-icon dense @click="removePattern('BHEAD', indexHeaders)">
                    mdi-minus
                  </v-icon>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
          <v-col cols="12" md="12" class="pl-0 pr-0">
            <v-label>Body</v-label>
            <v-textarea solo hide-details v-model="formData.baererBody"></v-textarea>
          </v-col>
          <v-col cols="12" md="12" class="pl-0 pr-4 mb-2 pt-4">
            <v-row class="ml-0 mr-0 d-block">
              <v-col lg="12" class="pa-0">
                <v-label
                  >Token Response Mapping (Please map "key-value" [from get Token Response] in below
                  input field.
                </v-label>
              </v-col>
              <v-tooltip top :disabled="bearerRespList.length < maxPattern">
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="btn-tooltip">
                    <v-col lg="6" class="pa-0 mb-1 text-right">
                      <v-icon
                        dense
                        @click="addPattern('RHEAD')"
                        :disabled="!$auth.manage || bearerRespList.length > maxPattern - 1"
                      >
                        mdi-plus
                      </v-icon>
                    </v-col>
                  </div>
                </template>
                <span v-html="$t('lbl.communications.validMaxPattern')"></span>
              </v-tooltip>
            </v-row>
            <v-form
              ref="formHeaders"
              class="dialog-content pr-0 mb-2"
              v-on:submit.prevent="doNoThing"
            >
              <v-row
                class="ml-0 mr-0 mb-4 edi-identification"
                v-for="(item, indexHeaders) in bearerRespList"
                :key="indexHeaders"
              >
                <v-col cols="12" md="4" class="pa-0">
                  <v-tooltip top :disabled="!item.isValidatePattern">
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <v-text-field
                          :ref="'RHEAD_' + indexHeaders"
                          solo
                          hide-details
                          v-model="item.keyHeader"
                        ></v-text-field>
                      </div>
                    </template>
                    <span v-html="$t('lbl.communications.validDuplicatePattern')"></span>
                  </v-tooltip>
                </v-col>
                <v-col cols="12" md="7" class="pa-0 pl-2">
                  <v-text-field
                    :ref="'RHEAD_' + indexHeaders + '_' + indexHeaders"
                    solo
                    hide-details
                    v-model="item.valueHeader"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="1" class="pa-0 mt-2 text-center">
                  <v-icon dense @click="removePattern('RHEAD', indexHeaders)">
                    mdi-minus
                  </v-icon>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
        </v-col>
        <v-col cols="12" md="12" class="px-2 pt-5" v-if="formData.authType == 'oauth2'">
          <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Grant Type</v-label>
          <v-select
            v-model="formData.grantType"
            :items="grantTypeList"
            solo
            :menu-props="{ offsetY: true }"
            :disabled="!$auth.manage"
            :readonly="isHistory"
            :rules="[validationUtils.required]"
          ></v-select>
          <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Token URI</v-label>
          <v-text-field
            v-model="formData.accessToken"
            solo
            :menu-props="{ offsetY: true }"
            :disabled="!$auth.manage"
            :readonly="isHistory"
            :rules="[validationUtils.required, validationUtils.max(250)]"
          ></v-text-field>
          <v-row>
            <v-col cols="12" md="2" style="margin-top: 18px;">
              <v-label>Basic Auth</v-label>
            </v-col>
            <v-col cols="12" md="5">
              <v-text-field
                v-model="formData.authId"
                solo
                hide-details
                :menu-props="{ offsetY: true }"
                :disabled="!$auth.manage"
                :rules="formData.authId ? [validationUtils.max(50)] : []"
                :readonly="isHistory"
                autocomplete="off"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="5">
              <v-text-field
                v-model="formData.authPass"
                :rules="formData.authPass ? [validationUtils.max(100)] : []"
                :append-icon="formData.showpassword ? 'mdi-eye-off' : 'mdi-eye'"
                :type="formData.showpassword ? 'text' : 'password'"
                @click:append="formData.showpassword = !formData.showpassword"
                solo
                :disabled="!$auth.manage"
                autocomplete="off"
                @focus="handlePasswordType"
                @blur="handlePasswordType"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="2" style="margin-top: 18px;">
              <v-label>API Key</v-label>
            </v-col>
            <v-col cols="12" md="5">
              <v-text-field
                v-model="formData.authKey"
                solo
                hide-details
                :menu-props="{ offsetY: true }"
                :disabled="!$auth.manage"
                :rules="formData.authKey ? [validationUtils.max(10)] : []"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="5">
              <v-text-field
                v-model="formData.authToken"
                solo
                hide-details
                :menu-props="{ offsetY: true }"
                :disabled="!$auth.manage"
                :rules="formData.authToken ? [validationUtils.max(2505)] : []"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mx-0 d-flex">
            <v-col lg="4" class="d-flex align-center pa-0">
              <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Token Headers</v-label>
              <v-tooltip top :disabled="tokenHeads.length < maxPattern">
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="btn-tooltip ml-2">
                    <v-col lg="1" class="pa-0 text-right">
                      <v-icon
                        dense
                        @click="addPattern('THEAD')"
                        :disabled="!$auth.manage || tokenHeads.length > maxPattern - 1"
                        :readonly="isHistory"
                      >
                        mdi-plus
                      </v-icon>
                    </v-col>
                  </div>
                </template>
                <span v-html="$t('lbl.communications.validMaxPattern')"></span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-form
            ref="tokenHeads"
            class="form-identification px-3 pb-6"
            v-on:submit.prevent="doNoThing"
          >
            <v-row
              class="px-0 py-0 edi-identification-right"
              v-for="(item, index) in tokenHeads"
              :key="item.id"
            >
              <v-col cols="12" md="4" class="pa-0">
                <v-tooltip top :disabled="!item.isValidatePattern">
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <v-text-field
                        :ref="'THEAD_' + item.id"
                        solo
                        hide-details
                        v-model="item.keyHeader"
                        @mouseleave="resetSetPattern('THEAD')"
                        :rules="[validationUtils.required]"
                        :disabled="!$auth.manage"
                        :readonly="isHistory"
                      ></v-text-field>
                    </div>
                  </template>
                  <span v-html="$t('lbl.communications.validDuplicatePattern')"></span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" md="7" class="pa-0 pl-4">
                <v-text-field
                  :ref="'THEAD_' + item.id + '_' + item.id"
                  solo
                  hide-details
                  v-model="item.valueHeader"
                  :rules="[validationUtils.required]"
                  :disabled="!$auth.manage"
                  :readonly="isHistory"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1" class="pa-0 mt-4 text-center">
                <v-icon
                  dense
                  :disabled="!$auth.manage"
                  :readonly="isHistory"
                  @click="removePattern('THEAD', index)"
                >
                  mdi-minus
                </v-icon>
              </v-col>
            </v-row>
          </v-form>
          <v-row class="mx-0 d-flex">
            <v-col lg="5" class="d-flex align-center pa-0">
              <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Token Config</v-label>
              <v-tooltip top :disabled="tokenConfigs.length < maxPattern">
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="btn-tooltip ml-2">
                    <v-col lg="1" class="pa-0 text-right">
                      <v-icon
                        dense
                        @click="addPattern('TCONF')"
                        :disabled="!$auth.manage || tokenConfigs.length > maxPattern - 1"
                        :readonly="isHistory"
                      >
                        mdi-plus
                      </v-icon>
                    </v-col>
                  </div>
                </template>
                <span v-html="$t('lbl.communications.validMaxPattern')"></span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-form
            ref="tokenConfigs"
            class="form-identification px-3 pb-6"
            v-on:submit.prevent="doNoThing"
          >
            <v-row
              class="px-0 py-0 edi-identification-right"
              v-for="(item, index) in tokenConfigs"
              :key="item.id"
            >
              <v-col cols="12" md="4" class="pa-0">
                <v-tooltip top :disabled="!item.isValidatePattern">
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <v-text-field
                        :ref="'TCONF_' + item.id"
                        solo
                        hide-details
                        v-model="item.keyHeader"
                        @mouseleave="resetSetPattern('TCONF')"
                        :rules="[validationUtils.required]"
                        :disabled="!$auth.manage"
                        :readonly="isHistory"
                      ></v-text-field>
                    </div>
                  </template>
                  <span v-html="$t('lbl.communications.validDuplicatePattern')"></span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" md="7" class="pa-0 pl-4">
                <v-text-field
                  :ref="'TCONF_' + item.id + '_' + item.id"
                  solo
                  hide-details
                  v-model="item.valueHeader"
                  :rules="[validationUtils.required]"
                  :disabled="!$auth.manage"
                  :readonly="isHistory"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1" class="pa-0 mt-4 text-center">
                <v-icon
                  dense
                  :disabled="!$auth.manage"
                  :readonly="isHistory"
                  @click="removePattern('TCONF', index)"
                >
                  mdi-minus
                </v-icon>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="12"
          :class="['px-2', callbackList.length > 0 ? 'mb-0' : 'mb-4']"
          v-if="formData.protocol && formData.protocol.indexOf('HTTP') != -1"
        >
          <v-row class="mx-0 d-flex">
            <v-col lg="2" class="d-flex align-center pa-0">
              <v-label>Callbacks</v-label>
              <v-tooltip top :disabled="callbackList.length < maxPattern">
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="btn-tooltip ml-2">
                    <v-col lg="1" class="pa-0 text-right">
                      <v-icon
                        dense
                        @click="addPattern('Callbacks')"
                        :disabled="!$auth.manage || callbackList.length > maxPattern - 1"
                        :readonly="isHistory"
                      >
                        mdi-plus
                      </v-icon>
                    </v-col>
                  </div>
                </template>
                <span v-html="$t('lbl.communications.validMaxPattern')"></span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-form
            ref="callbacks"
            class="dialog-content pr-0 mb-2 py-0"
            style="min-height: 400px"
            v-if="callbackList.length > 0"
          >
            <v-row
              class="px-0 mb-5 mr-1 py-0 edi-identification callbacks-soap"
              v-for="(item, index) in callbackList"
              :key="item.id"
              style="height: auto"
            >
              <v-col cols="12" md="12" class="text-right">
                <v-btn
                  small
                  text
                  icon
                  :disabled="!$auth.manage"
                  :readonly="isHistory"
                  @click="removePattern('Callbacks', index)"
                >
                  <icon-svg iconName="close" />
                </v-btn>
              </v-col>
              <v-col cols="12" md="6" class="px-2 py-0">
                <v-row>
                  <v-col cols="12" md="12" class="py-0">
                    <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Type</v-label>
                    <v-tooltip top :disabled="!item.isValidatePattern">
                      <template v-slot:activator="{ on }">
                        <div v-on="on">
                          <v-select
                            :ref="'CALL_' + item.id"
                            v-model="item.callbackLabel"
                            :items="callbackMethodList"
                            @change="resetSetPattern('Callbacks')"
                            solo
                            :menu-props="{ offsetY: true }"
                            :disabled="!$auth.manage"
                            :readonly="isHistory"
                            :rules="[validationUtils.required]"
                          ></v-select>
                        </div>
                      </template>
                      <span v-html="$t('lbl.communications.validDuplicatePattern')"></span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="6" class="px-2 py-0">
                <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Method</v-label>
                <v-select
                  v-model="item.methodCallback"
                  :items="methodCallbacks"
                  solo
                  :menu-props="{ offsetY: true }"
                  :rules="[validationUtils.required]"
                  :disabled="!$auth.manage"
                  :readonly="isHistory"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6" class="pl-2 pr-4">
                <v-row class="mx-0 d-flex">
                  <v-col lg="3" class="d-flex align-center pa-0">
                    <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Headers</v-label>
                  </v-col>
                  <v-tooltip top :disabled="callbackList[index].headersList.length < maxPattern">
                    <template v-slot:activator="{ on }">
                      <div v-on="on" class="btn-tooltip ml-2">
                        <v-col lg="1" class="pa-0 text-right">
                          <v-icon
                            dense
                            @click="addPattern('Headers', index)"
                            :disabled="
                              !$auth.manage ||
                                callbackList[index].headersList.length > maxPattern - 1
                            "
                            :readonly="isHistory"
                          >
                            mdi-plus
                          </v-icon>
                        </v-col>
                      </div>
                    </template>
                    <span v-html="$t('lbl.communications.validMaxPattern')"></span>
                  </v-tooltip>
                </v-row>
              </v-col>
              <v-col cols="12" md="12" class="pl-0 pr-4">
                <v-form
                  ref="formHeaders"
                  class="form-identification px-5 pb-6"
                  v-on:submit.prevent="doNoThing"
                >
                  <v-row
                    class="px-0 py-0 edi-identification-right"
                    v-for="(item, indexHeaders) in callbackList[index].headersList"
                    :key="indexHeaders"
                  >
                    <v-col cols="12" md="4" class="pa-0">
                      <v-tooltip top :disabled="!item.isValidatePattern">
                        <template v-slot:activator="{ on }">
                          <div v-on="on">
                            <v-text-field
                              :ref="'PTTN_' + index + '_' + indexHeaders"
                              solo
                              hide-details
                              v-model="item.keyHeader"
                              @mouseleave="resetSetPattern('Headers', index)"
                              :rules="[validationUtils.required]"
                              :disabled="!$auth.manage"
                              :readonly="isHistory"
                            ></v-text-field>
                          </div>
                        </template>
                        <span v-html="$t('lbl.communications.validDuplicatePattern')"></span>
                      </v-tooltip>
                    </v-col>
                    <v-col cols="12" md="7" class="pa-0 pl-4">
                      <v-text-field
                        :ref="'PTTN_' + index + '_' + indexHeaders + '_' + indexHeaders"
                        solo
                        hide-details
                        v-model="item.valueHeader"
                        :rules="[validationUtils.required]"
                        :disabled="!$auth.manage"
                        :readonly="isHistory"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="1" class="pa-0 mt-4 text-center">
                      <v-icon
                        dense
                        :disabled="!$auth.manage"
                        :readonly="isHistory"
                        @click="removePattern('Headers', index, indexHeaders)"
                      >
                        mdi-minus
                      </v-icon>
                    </v-col>
                  </v-row>
                </v-form>
              </v-col>
              <v-col cols="12" md="12" class="px-2 py-0">
                <v-label>Body</v-label>
                <v-textarea
                  solo
                  :disabled="!$auth.manage"
                  :readonly="isHistory"
                  v-model="item.callbackBody"
                ></v-textarea>
              </v-col>
              <v-col cols="12" md="12" class="px-2 py-0">
                <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>URI</v-label>
                <v-text-field
                  v-model="item.uri"
                  solo
                  :rules="[validationUtils.required]"
                  :disabled="!$auth.manage"
                  :readonly="isHistory"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-form>
    <dialogWindow
      ref="DuplicatePatternDialog"
      size="max"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
    >
    </dialogWindow>
  </div>
</template>

<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import { getEditData } from '@/vue-caas/utils/process';

export default {
  components: {
    dialogWindow,
    IconSvg,
  },
  props: {
    item: {
      default: Object,
    },
    nodeId: {
      type: String,
    },
    isHistory: {
      default: false,
    },
  },

  data() {
    return {
      formData: {},
      loadFormData: {},
      formError: {
        name: {
          message: '',
        },
      },
      /**
       * 06/11/2021 203737 SPKA-138 issue 88 Add the "REST API" type in communication
       */
      methods: [
        { text: 'GET', value: 'GET' },
        { text: 'PUT', value: 'PUT' },
        { text: 'DELETE', value: 'DELETE' },
        { text: 'POST', value: 'POST' },
      ],
      intervals: [
        { text: this.$t('msg.communications.seconds'), value: 'SS' },
        { text: this.$t('msg.communications.minutes'), value: 'MM' },
        { text: this.$t('msg.communications.hours'), value: 'HH' },
      ],
      intervalDefault: {
        text: this.$t('msg.communications.minutes'),
        value: 'MM',
      },
      authList: [],
      grantTypeList: [],
      listHttpHeaders: [],
      protocolList: [],
      tokenHeads: [],
      bearerHeadersList: [],
      bearerRespList: [],
      tokenConfigs: [],
      maxPattern: 5,
      setPatternHead: new Set(),
      setPatternConfig: new Set(),
      checkDialogInfo: '',
      checkDialogColor: 'warning',
      callbackList: [],
      headersList: [],
      callbackMethodList: [],
      methodCallbacks: [
        { value: 'GET', text: 'GET' },
        { value: 'PUT', text: 'PUT' },
        { value: 'DELETE', text: 'GET' },
        { value: 'POST', text: 'POST' },
      ],
      callbackLabel: '',
      httpHeaderType: [],
      setPatternCallback: new Set(),
      setPatternCallHead: [],
    };
  },
  created() {
    this.resetFormData();
  },

  watch: {
    item() {
      this.resetFormData();
      // this.setFocus();
    },
  },

  methods: {
    handlePasswordType(event) {
      const { srcElement, type } = event;
      const { value } = srcElement;
      if (type === 'focus' && !value) {
        this.formData.showpassword = false;
      }
      if (type === 'blur' && !value) {
        this.formData.showpassword = true;
      }
    },
    isJson(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    checkDataChange() {
      let editedData = getEditData(this.formData, this.loadFormData);
      this.$emit('check-data-change', editedData);
    },
    async save(item) {
      let validResult = this.$refs.form.validate();
      if (!validResult) return -1;
      this.formData.id = item.id;
      this.formData.type = item.type;
      this.formData.name = item.name;
      console.log('Save');
      if (this.formData.authType == 'basic') {
        this.formData.tokenHeads = {};
        this.formData.tokenConfigs = {};
        this.formData.grantType = '';
        this.formData.accessToken = '';
        this.formData.authKey = '';
        this.formData.authToken = '';
        this.formData.authClientID = '';
        this.formData.bearerHeadersList = {};
        this.formData.bearerRespList = {};
      } else if (this.formData.authType == 'apikey') {
        this.formData.tokenHeads = {};
        this.formData.tokenConfigs = {};
        this.formData.grantType = '';
        this.formData.accessToken = '';
        this.formData.authId = '';
        this.formData.authPass = '';
        this.formData.authClientID = '';
        this.formData.bearerHeadersList = {};
        this.formData.bearerRespList = {};
      } else if (this.formData.authType == 'bearer') {
        this.formData.tokenHeads = {};
        this.formData.grantType = '';

        this.formData.tokenConfigs = JSON.stringify(this.formData.baererBody);

        let indexValidPatternHttpHeaders, found;
        if (this.bearerHeadersList.length > 0) {
          indexValidPatternHttpHeaders = this.bearerHeadersList.findIndex(
            (e) => e.keyHeader === '' || e.valueHeader === '',
          );
          if (indexValidPatternHttpHeaders > -1) {
            let itemPattern = this.bearerHeadersList[indexValidPatternHttpHeaders];
            this.$refs[
              `BHEAD_${itemPattern.id}${itemPattern.keyHeader === '' ? '' : '_' + itemPattern.id}`
            ][0].focus();
            return -1;
          }
          found = this.bearerHeadersList.find((element) => element.isValidatePattern);
          if (found) {
            this.$refs['BHEAD_' + found.id][0].focus();
            return -1;
          }
        }

        if (this.bearerRespList.length > 0) {
          indexValidPatternHttpHeaders = this.bearerRespList.findIndex(
            (e) => e.keyHeader === '' || e.valueHeader === '',
          );
          if (indexValidPatternHttpHeaders > -1) {
            let itemPattern = this.bearerRespList[indexValidPatternHttpHeaders];
            this.$refs[
              `RHEAD_${itemPattern.id}${itemPattern.keyHeader === '' ? '' : '_' + itemPattern.id}`
            ][0].focus();
            return -1;
          }
          found = this.bearerRespList.find((element) => element.isValidatePattern);
          if (found) {
            this.$refs['RHEAD_' + found.id][0].focus();
            return -1;
          }
        }

        this.formData.tokenHeads = this.convertArrayObjectToJson(this.bearerHeadersList);
        this.formData.bearerRespList = this.convertArrayObjectToJson(this.bearerRespList);
      } else if (this.formData.authType == 'oauth2') {
        if (this.tokenHeads.length == 0) {
          this.$refs.DuplicatePatternDialog.dialog = true;
          this.checkDialogInfo = this.$t('msg.communications.validEmptyThead');
          return -1;
        }
        if (this.tokenConfigs.length == 0) {
          this.$refs.DuplicatePatternDialog.dialog = true;
          this.checkDialogInfo = this.$t('msg.communications.validEmptyTConfig');
          return -1;
        }
        let indexValidPatternHttpHeaders = this.tokenHeads.findIndex(
          (e) => e.keyHeader === '' || e.valueHeader === '',
        );
        if (indexValidPatternHttpHeaders > -1) {
          let itemPattern = this.tokenHeads[indexValidPatternHttpHeaders];
          this.$refs[
            `THEAD_${itemPattern.id}${itemPattern.keyHeader === '' ? '' : '_' + itemPattern.id}`
          ][0].focus();
          return -1;
        }

        indexValidPatternHttpHeaders = this.tokenConfigs.findIndex(
          (e) => e.keyHeader === '' || e.valueHeader === '',
        );
        if (indexValidPatternHttpHeaders > -1) {
          let itemPattern = this.tokenConfigs[indexValidPatternHttpHeaders];
          this.$refs[
            `TCONF_${itemPattern.id}${itemPattern.keyHeader === '' ? '' : '_' + itemPattern.id}`
          ][0].focus();
          return -1;
        }

        let found = this.tokenHeads.find((element) => element.isValidatePattern);
        if (found) {
          this.$refs['THEAD_' + found.id][0].focus();
          return -1;
        }
        found = this.tokenConfigs.find((element) => element.isValidatePattern);
        if (found) {
          this.$refs['TCONF_' + found.id][0].focus();
          return -1;
        }
        this.formData.tokenHeads = this.convertArrayObjectToJson(this.tokenHeads);
        this.formData.tokenConfigs = this.convertArrayObjectToJson(this.tokenConfigs);
        this.formData.authClientID = '';
        this.formData.bearerHeadersList = {};
        this.formData.bearerRespList = {};
      }
      /**
       * 06/11/2021 203737 SPKA-138 issue 88 Add the "REST API" type in communication
       */
      let indexValidHeader = this.listHttpHeaders.findIndex(
        (e) => e.keyHeader === '' || e.valueHeader === '',
      );
      if (indexValidHeader > -1) {
        let itemHeader = this.listHttpHeaders[indexValidHeader];
        this.$refs[
          `HTTP_${itemHeader.id}${itemHeader.keyHeader === '' ? '' : '_' + itemHeader.id}`
        ][0].focus();
        return -1;
      }

      this.formData.httpHeaders = this.convertArrayObjectToJson(this.listHttpHeaders);

      if (this.formData.protocol.indexOf('HTTP') === -1) {
        this.callbackList = [];
      }

      if (this.formData.protocol.indexOf('HTTP') !== -1 && this.formData.selfCert == true) {
        this.formData.selfCert = 'Y';
      } else {
        this.formData.selfCert = '';
      }

      if (this.callbackList.length > 0) {
        let validResult = this.$refs.callbacks.validate();
        if (!validResult) return;
      }

      for (let i = 0; i < this.callbackList.length; i++) {
        let item = this.callbackList[i];
        if (item.headersList.length == 0) {
          this.$refs.DuplicatePatternDialog.dialog = true;
          this.checkDialogInfo = this.$t('msg.communications.validEmptyHeaders');
          return -1;
        }
        let indexValidPatternHeaders = item.headersList.findIndex(
          (e) => e.keyHeader === '' || e.valueHeader === '',
        );
        if (indexValidPatternHeaders > -1) {
          let itemPattern = item.headersList[indexValidPatternHeaders];
          this.$refs[
            `PTTN_${i}_${itemPattern.id}${itemPattern.keyHeader === '' ? '' : '_' + itemPattern.id}`
          ][0].focus();
          return -1;
        }
        let found = item.headersList.find((element) => element.isValidatePattern);
        if (found) {
          this.$refs[`PTTN_${i}_${found.id}`][0].focus();
          return -1;
        }
      }
      // Get JSON Callbacks
      let callbacks = [];
      for (let i = 0; i < this.callbackList.length; i++) {
        let callback = {};
        let item = this.callbackList[i];
        callback = {
          method: item.methodCallback,
          headers: this.convertArrayObjectToJson(item.headersList),
          body: item.callbackBody,
          uri: item.uri,
        };
        callbacks.push({
          id: i,
          keyHeader: item.callbackLabel,
          valueHeader: callback,
        });
      }
      this.formData.callbacks = this.convertArrayObjectToJson(callbacks);
      let editedData = getEditData(this.formData, this.loadFormData);
      if (this.intervalDefault.value) {
        this.formData.intervalType = this.intervalDefault.value;
        editedData.intervalType = this.intervalDefault.value;
      }
      editedData.id = this.formData.id;
      editedData.name = this.formData.name;
      editedData.protocol = this.formData.type;
      if (this.formData.id) {
        await this.$store
          .dispatch('editCommFromProcSetup', this.formData)
          .then(() => {
            this.sendActivate(this.formData.id, 'COM', editedData);
            let formEmit = {
              comId: this.formData.id,
              nodeId: this.nodeId,
              type: 'COM',
            };
            EventBus.$emit('refresh-list-component', formEmit);
          })
          .catch((err) => {
            alert(err);
          });
      } else {
        await this.$store
          .dispatch('insertCommFromProcSetup', this.formData)
          .then(() => {
            this.formData.id = this.$store.getters.communicationId;
            let formEmit = {
              comId: this.formData.id,
              nodeId: this.nodeId,
              type: 'COM',
            };
            EventBus.$emit('refresh-list-component', formEmit);
          })
          .catch((err) => {
            alert(err);
          });
      }
    },
    async sendActivate(comId, comTp, info) {
      const params = {
        comId: comId,
        comTp: comTp,
        info: info,
      };
      await this.$store.dispatch('updateProcessInfo', params);
    },

    getInitData() {
      return {
        name: '',
        partner: '',
        direction: '',
        host: '',
        // security : '',
        port: '',
        // userid : '',
        // password : '',
        showpassword: true,
        type: 'API',
        authType: '',
        authId: '',
        authPass: '',
        authKey: '',
        authToken: '',
        accessToken: '',
        authClientID: '',
        baererBody: '',
      };
    },
    // hasEditForm() {
    //   const defaultForm = this.getInitData();
    //   for (const prop in defaultForm) {
    //     if (prop != 'showpassword' && prop != 'type') {
    //       if (this.formData[prop].trim() != '') {
    //         return true;
    //       }
    //     }
    //   }
    //   return false;
    // },
    resetFormData() {
      this.formData = Object.assign({}, this.getInitData(), this.item);
      this.loadFormData = Object.assign({}, this.getInitData(), this.item);
      if (!this.formData.interval) {
        this.formData.interval = '30';
      }

      if (this.item.intervalType) {
        this.intervalDefault = this.intervals.filter(
          (item) => item.value === this.item.intervalType,
        )[0];
      } else {
        this.intervalDefault = {
          text: this.$t('msg.communications.minutes'),
          value: 'MM',
        };
      }
      this.authList = [];
      this.grantTypeList = [];
      this.callbackList = [];
      this.headersList = [];
      this.callbackMethodList = [];
      this.tokenHeads = [];
      this.tokenConfigs = [];
      this.setPatternHead = new Set();
      this.setPatternConfig = new Set();
      this.setPatternCallback = new Set();
      this.setPatternCallHead = [];
      this.callbackLabel = '';
      this.listHttpHeaders = [];

      this.getProtocolList();
      this.getAuthTypeList();
      this.getGrantTypeList();
      this.getListComboFilenamePattern();

      let emptyObj = this.formData.httpHeaders;
      if (emptyObj && emptyObj.constructor === Object && Object.keys(emptyObj).length > 0) {
        if (this.formData.httpHeaders) {
          this.listHttpHeaders = this.convertJsonToArrayObject(this.formData.httpHeaders);
        }
      }
      if (this.formData.id) {
        emptyObj = this.formData.tokenHeads;

        if (emptyObj && emptyObj.constructor === Object && Object.keys(emptyObj).length > 0) {
          this.tokenHeads = this.convertJsonToArrayObject(this.formData.tokenHeads);
        }

        emptyObj = this.formData.tokenConfigs;
        if (emptyObj && emptyObj.constructor === Object && Object.keys(emptyObj).length > 0) {
          this.tokenConfigs = this.convertJsonToArrayObject(this.formData.tokenConfigs);
        }

        if (this.formData.authType == 'bearer') {
          const obj = this.formData.tokenConfigs;
          if (this.isJson(obj)) {
            const pretty = JSON.stringify(JSON.parse(obj), undefined, 4);
            this.formData.baererBody = pretty;
            this.loadFormData.baererBody = pretty;
          } else {
            this.formData.baererBody = obj;
            this.loadFormData.baererBody = obj;
          }
        } else {
          emptyObj = this.formData.tokenConfigs;
          if (emptyObj && emptyObj.constructor === Object && Object.keys(emptyObj).length > 0) {
            this.tokenConfigs = this.convertJsonToArrayObject(this.formData.tokenConfigs);
          }
        }

        emptyObj = this.formData.tokenHeads;
        if (emptyObj && emptyObj.constructor === Object && Object.keys(emptyObj).length > 0) {
          this.bearerHeadersList = this.convertJsonToArrayObject(this.formData.tokenHeads);
        }

        emptyObj = this.formData.bearerRespList;
        if (emptyObj && emptyObj.constructor === Object && Object.keys(emptyObj).length > 0) {
          this.bearerRespList = this.convertJsonToArrayObject(this.formData.bearerRespList);
        }

        this.callbackList = [];
        emptyObj = this.formData.callbacks;
        if (emptyObj && emptyObj.constructor === Object && Object.keys(emptyObj).length > 0) {
          Object.entries(this.formData.callbacks).forEach(([key, value], index) => {
            let callbackValue = {};
            callbackValue.id = index;
            callbackValue.callbackLabel = key;
            callbackValue.callbackBody = value.body;
            callbackValue.headersList = [];
            Object.entries(value.headers).forEach(([key, value], index) => {
              callbackValue.headersList.push({
                id: index,
                keyHeader: key,
                valueHeader: value,
              });
            });
            callbackValue.uri = value.uri;
            callbackValue.methodCallback = value.method;
            this.callbackList.push(callbackValue);
          });
        }
      } else {
        this.tokenConfigs = [
          {
            id: 0,
            keyHeader: 'grant_type',
            valueHeader: 'client_credentials',
            isValidatePattern: false,
          },
        ];
      }
      if (this.$refs.form) this.$refs.form.resetValidation();
    },
    setFieldValidation(name, message) {
      this.formError[name] = {
        message,
      };
    },
    setFocus() {
      setTimeout(() => {
        this.$refs.name.focus();
      }, 300);
    },
    /**
     * 06/11/2021 203737 SPKA-138 issue 88 Add the "REST API" type in communication
     */
    validateInterval(item) {
      let interval = this.formData.interval;
      if (interval) {
        switch (item.value) {
          case 'SS': {
            if (interval < 10 || interval > 59) {
              return this.$t('msg.communications.validateInterval', ['10', '59', 'seconds']);
            }
            break;
          }
          case 'HH': {
            if (interval < 1 || interval > 24) {
              return this.$t('msg.communications.validateInterval', ['1', '24', 'hours']);
            }
            break;
          }
          default: {
            if (interval < 1 || interval > 59) {
              return this.$t('msg.communications.validateInterval', ['1', '59', 'minutes']);
            }
          }
        }
      }
      return true;
    },
    addHttpHeaders() {
      let index =
        this.listHttpHeaders.length > 0
          ? this.listHttpHeaders[this.listHttpHeaders.length - 1].id + 1
          : 1;
      this.listHttpHeaders.push({ id: index, keyHeader: '', valueHeader: '' });
    },
    removeHttpHeaders(index) {
      this.listHttpHeaders.splice(index, 1);
    },
    /**
     * 2021.16.06 203737 SPKA-138 issue 88 Add the "REST API" type in communication
     */
    convertArrayObjectToJson(listHttpHeaders) {
      let httpHeadersFormat;
      if (listHttpHeaders.length > 0) {
        httpHeadersFormat = listHttpHeaders.reduce(
          (obj, item) => Object.assign(obj, { [item.keyHeader]: item.valueHeader }),
          {},
        );
      } else {
        httpHeadersFormat = {};
      }
      return httpHeadersFormat;
    },
    /**
     * 2021.16.06 203737 SPKA-138 issue 88 Add the "REST API" type in communication
     * Check type string or object of httpHeaders
     */
    convertJsonToArrayObject(httpHeaders) {
      httpHeaders = typeof httpHeaders === 'string' ? JSON.parse(httpHeaders) : httpHeaders;
      let listHttpHeaders = [];
      Object.keys(httpHeaders).map((item, index) => {
        listHttpHeaders.push({
          id: index + 1,
          keyHeader: item,
          valueHeader: httpHeaders[item],
        });
      });
      return listHttpHeaders;
    },
    // 2021.8.23 203728 SPKA-198 get protocol list
    getProtocolList() {
      this.$store.dispatch('caascommon/getComCdList', { grpCd: 'P09' }).then(() => {
        let list = this.$store.getters['caascommon/comCdList'];
        list.map((item) => {
          this.protocolList.push({ text: item.text, value: item.value });
        });
      });
    },
    getAuthTypeList() {
      this.$store.dispatch('caascommon/getComCdList', { grpCd: 'P12' }).then(() => {
        let list = this.$store.getters['caascommon/comCdList'];
        this.authList.push({ text: 'Unused', value: '' });
        list.map((item) => {
          this.authList.push({ text: item.text, value: item.value });
        });
      });
    },
    getGrantTypeList() {
      this.$store.dispatch('caascommon/getComCdList', { grpCd: 'P13' }).then(() => {
        let list = this.$store.getters['caascommon/comCdList'];
        list.map((item) => {
          this.grantTypeList.push({ text: item.text, value: item.value });
        });
      });
    },
    addPattern(status, indexCallback) {
      let index = 0;
      switch (status) {
        case 'THEAD': {
          index =
            this.tokenHeads.length > 0 ? this.tokenHeads[this.tokenHeads.length - 1].id + 1 : 1;
          this.tokenHeads.push({
            id: index,
            keyHeader: '',
            valueHeader: '',
            isValidatePattern: false,
          });
          break;
        }
        case 'TCONF': {
          index =
            this.tokenConfigs.length > 0
              ? this.tokenConfigs[this.tokenConfigs.length - 1].id + 1
              : 1;
          this.tokenConfigs.push({
            id: index,
            keyHeader: '',
            valueHeader: '',
            isValidatePattern: false,
          });
          break;
        }
        case 'Callbacks': {
          index =
            this.callbackList.length > 0
              ? this.callbackList[this.callbackList.length - 1].id + 1
              : 1;
          let callbackHeaders = [];
          let headersList = {
            'Content-Type': 'application/json',
          };
          Object.entries(headersList).forEach(([key, value], index) => {
            callbackHeaders.push({
              id: index,
              keyHeader: key,
              valueHeader: value,
            });
          });
          this.callbackList.push({
            id: index,
            callbackLabel: '',
            methodCallback: '',
            callbackBody: '',
            uri: '',
            isValidatePattern: false,
            headersList: callbackHeaders,
          });
          break;
        }
        case 'Headers': {
          index =
            this.callbackList[indexCallback].headersList.length > 0
              ? this.callbackList[indexCallback].headersList[
                  this.callbackList[indexCallback].headersList.length - 1
                ].id + 1
              : 1;
          this.callbackList[indexCallback].headersList.push({
            id: index,
            keyHeader: '',
            valueHeader: '',
            isValidatePattern: false,
          });
          break;
        }
        case 'BHEAD': {
          index =
            this.bearerHeadersList.length > 0
              ? this.bearerHeadersList[this.bearerHeadersList.length - 1].id + 1
              : 1;
          this.bearerHeadersList.push({
            id: index,
            keyHeader: '',
            valueHeader: '',
            isValidatePattern: false,
          });
          break;
        }
        case 'RHEAD': {
          index =
            this.bearerRespList.length > 0
              ? this.bearerRespList[this.bearerRespList.length - 1].id + 1
              : 1;
          this.bearerRespList.push({
            id: index,
            keyHeader: '',
            valueHeader: '',
            isValidatePattern: false,
          });
          break;
        }
        default:
          break;
      }
    },
    removePattern(status, index, indexHeaders) {
      if (status == 'THEAD') {
        this.tokenHeads.splice(index, 1);
      } else if (status == 'TCONF') {
        this.tokenConfigs.splice(index, 1);
      } else if (status == 'Callbacks') {
        this.callbackList.splice(index, 1);
      } else if (status == 'Headers') {
        this.callbackList[index].headersList.splice(indexHeaders, 1);
      }
    },
    resetSetPattern(status, index) {
      if (status == 'THEAD') {
        this.setPatternHead.clear();
        for (let i = 0; i < this.tokenHeads.length; i++) {
          if (!this.tokenHeads[i].keyHeader) continue;
          if (this.setPatternHead.has(this.tokenHeads[i].keyHeader)) {
            this.tokenHeads[i].isValidatePattern = true;
          } else {
            this.setPatternHead.add(this.tokenHeads[i].keyHeader);
            this.tokenHeads[i].isValidatePattern = false;
          }
        }
      } else if (status == 'TCONF') {
        this.setPatternConfig.clear();
        for (let i = 0; i < this.tokenConfigs.length; i++) {
          if (!this.tokenConfigs[i].keyHeader) continue;
          if (this.setPatternConfig.has(this.tokenConfigs[i].keyHeader)) {
            this.tokenConfigs[i].isValidatePattern = true;
          } else {
            this.setPatternConfig.add(this.tokenConfigs[i].keyHeader);
            this.tokenConfigs[i].isValidatePattern = false;
          }
        }
      } else if (status == 'Callbacks') {
        let dup = false;
        this.setPatternCallback.clear();
        for (let i = 0; i < this.callbackList.length; i++) {
          if (!this.callbackList[i].callbackLabel) continue;
          if (this.setPatternCallback.has(this.callbackList[i].callbackLabel)) {
            dup = true;
            this.callbackList[i].isValidatePattern = true;
          } else {
            this.setPatternCallback.add(this.callbackList[i].callbackLabel);
            this.callbackList[i].isValidatePattern = false;
          }
        }
        if (dup) {
          this.$refs.DuplicatePatternDialog.dialog = true;
          this.checkDialogInfo = this.$t('msg.communications.validDuplicate');
          return -1;
        }
      } else if (status == 'Headers') {
        if (this.setPatternCallHead[index]) this.setPatternCallHead[index].clear();
        else this.setPatternCallHead[index] = new Set();

        let data = this.callbackList[index].headersList;

        for (let i = 0; i < data.length; i++) {
          if (!data[i].keyHeader) continue;
          if (this.setPatternCallHead[index].has(data[i].keyHeader)) {
            data[i].isValidatePattern = true;
          } else {
            this.setPatternCallHead[index].add(data[i].keyHeader);
            data[i].isValidatePattern = false;
          }
        }
      }
    },
    doNoThing() {
      console.log('Skip Enter');
    },
    getListComboFilenamePattern() {
      this.$store.dispatch('caascommon/getComCdList', { grpCd: 'P11' }).then(() => {
        let list = this.$store.getters['caascommon/comCdList'];
        list.map((item) => {
          this.callbackMethodList.push({
            text: item.text,
            value: item.value,
          });
        });
      });
    },
  },
};
</script>
<style></style>
